/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unsafe-argument */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */

import { Modal } from "bootstrap";

export class PageRatingComponent {
    private _window: JQuery<Window> = null;
    private _currentContext: JQuery = null;

    private classMap: any = {
        control: ".js-pcg-rating__control",
        modalWindow: ".js-pcg-rating__modal",
        submitComment: ".js-pcg-rating__submit-comment",
        comment: ".js-pcg-rating__comment",
        modalIcon: ".js-pcg-rating__modal-icon",
        modalTitle: ".js-pcg-rating__modal-title",
        modalSubTitle: ".js-pcg-rating__modal-subtitle",
        modalHeading: ".js-pcg-rating__modal-heading"
    };

    private _form: JQuery = null;
    private _warning: JQuery = null;
    private _contactMethod: JQuery = null;
    private _email: JQuery = null;
    private _phone: JQuery = null;
    private _modal: Modal = null;

    private modal: Modal = null;
    private $controls: JQuery = null;
    private $modal: JQuery = null;
    private $modalIcon: JQuery = null;
    private $modalTitle: JQuery = null;
    private $modalSubTitle: JQuery = null;
    private $modalComment: JQuery = null;
    private $modalSubmit: JQuery = null;
    private $modalHeading: JQuery = null;

    public static init(context: JQuery): PageRatingComponent {
        const component = new PageRatingComponent();
        component.init(context);
        return component;
    }

    public init(context: JQuery): void {
        this._currentContext = context || this._currentContext;

        this.parseContext();
        this.bindEvents();

        console.debug("PageRatingComponent::init >> this:", this);
    }

    private parseContext(): void {
        this._window = $(window);

        this._warning = $(".js-pcg-validation-result", this._currentContext);
        this._form = $(".js-pcg-contact-form", this._currentContext);
        this._contactMethod = $(".js-pcg-custom-radio--contact-method", this._currentContext);
        this._email = $(".js-pcg-form-group-email", this._currentContext);
        this._phone = $(".js-pcg-form-group-phone", this._currentContext);

        this._modal = new Modal(this._currentContext[0], {} as Partial<Modal.Options>);

        // ***

        this.$controls = $(this.classMap.control, this._currentContext);

        this.modal = new Modal(this.classMap.modalWindow, {} as Partial<Modal.Options>);

        this.$modal = $(this.classMap.modalWindow, this._currentContext);
        this.$modalIcon = $(this.classMap.modalIcon, this.$modal);
        this.$modalTitle = $(this.classMap.modalTitle, this.$modal);
        this.$modalSubTitle = $(this.classMap.modalSubTitle, this.$modal);
        this.$modalComment = $(this.classMap.comment, this.$modal);
        this.$modalSubmit = $(this.classMap.submitComment, this.$modal);
        this.$modalHeading = $(this.classMap.modalHeading, this.$modal);
    }

    private bindEvents(): void {
        this.$controls.on("click", (e) => {
            e.preventDefault();

            if (!this.isAlreadyRated) {
                // var $chosenRating = $(this);
                // setRating($chosenRating);
                // openModal($chosenRating);
            }
        });
        // $modalSubmit.on("click", function () {
        //     setComment();
        //     modal.hide();
        // });
        // $modal.on("hide.bs.modal", function(){
        //     postRating();
        //     $modalComment.val("");
        // });
    }

    // var $currentContext = $(document);
    // var moduleOptions = {
    //     submitRatingUrl: "",
    //     pageId: null,
    // };

    private isAlreadyRated = false;
    // var data = {
    //     rating: null,
    //     comment: "",
    // };

    // var getPageId = () => {return $currentContext.data("pageId")};
    // var getRating = ($element) => $element.data("ratingValue");
    // var getIconLabel = ($rating) => $rating.data("title");

    // private postRating(): void {
    //     this.isAlreadyRated = true;
    //     $.ajax({
    //         type: "POST",
    //         url: moduleOptions.submitRatingUrl,
    //         data: {
    //             pageId: getPageId(),
    //             rating: data.rating,
    //             comment: data.comment
    //         },
    //     }).fail(function () {
    //         isAlreadyRated = false;
    //     });
    // }

    // function setRating($chosenRating) {
    //     data.rating = getRating($chosenRating);
    // }

    // function setComment() {
    //     data.comment = $modalComment.val();
    // }

    // function openModal($chosenRating) {
    //     $modalIcon.attr("data-label", getIconLabel($chosenRating));
    //     $modalTitle.text($chosenRating.data("modal-title"));
    //     $modalSubTitle.text($chosenRating.data("modal-subtitle"));
    //     $modalHeading.text($chosenRating.data("modal-heading"));
    //     modal.show();
    // }
}
